(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kowe-scroll-story"] && !Shopify.designMode) return;
  try {
    

  (function () {
    function initializeKoweStory(root) {
    if (!root || root.dataset.koweInitialized === 'yes') return;
    var scenes = Array.prototype.slice.call(root.querySelectorAll('.kowe-story__scene'));
    var stage = root.querySelector('.kowe-story__stage');
    var rakel = root.querySelector('.kowe-story__rakel');
    var pull = root.querySelector('.kowe-story__pull');
    var pullImage = pull ? pull.querySelector('.kowe-story__pull-image') : null;
    var hint = root.querySelector('.kowe-story__hint');
    if (!scenes.length || !stage || !rakel) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var revealEnd = Math.max(.25, Math.min(.60, parseFloat(root.dataset.revealRatio) || .40));
    var pauseValue = parseFloat(root.dataset.readingPause);
    var pauseShare = isNaN(pauseValue) ? .50 : Math.max(0, Math.min(.80, pauseValue));
    var wipeStart = revealEnd + (1 - revealEnd) * pauseShare;
    var baseUnits = parseFloat(root.dataset.scrollVh) || 100;
    var configuredLag = parseFloat(root.dataset.rakelLag);
    var bladeLag = isNaN(configuredLag) ? 26 : Math.max(0, Math.min(100, configuredLag));
    var smoothPull = root.dataset.smoothPull !== 'false';
    var smoothRakel = root.dataset.smoothRakel !== 'false';
    var pullEdgeValue = Number(root.dataset.pullEdge);
    var pullEdgePercent = Math.max(0, Math.min(35, isNaN(pullEdgeValue) ? 12 : pullEdgeValue)) / 100;
    var frame = 0;
    var active = false;
    root.dataset.koweInitialized = 'yes';
    var sceneUnits = scenes.map(function(scene) {
      var extra = Number(scene.dataset.extraVh) || 0;
      return baseUnits + Math.max(0, extra);
    });
    var totalUnits = sceneUnits.reduce(function(acc, value) {return acc + value;}, 0);
    function clamp(x, lo, hi) {return Math.max(lo, Math.min(hi, x));}
    function smoothstep(x) {x = clamp(x,0,1); return x*x*(3-2*x);}
    function getScrollState() {
      var available = Math.max(1, root.offsetHeight - stage.offsetHeight);
      var scrolled = clamp(-root.getBoundingClientRect().top, 0, available);
      var unitPosition = scrolled / available * totalUnits;
      var index = 0;
      var offset = 0;
      while (index < scenes.length - 1 && unitPosition >= offset + sceneUnits[index]) {
        offset += sceneUnits[index];
        index += 1;
      }
      return {index:index, local:clamp(unitPosition - offset, 0, sceneUnits[index]), offset:offset, available:available};
    }
    function draw() {
      frame = 0;
      if (!active) return;
      var state = getScrollState();
      var current = state.index;
      var local = state.local;
      var extra = Math.max(0, sceneUnits[current] - baseUnits);
      var revealUnits = baseUnits * revealEnd;
      var wipeStartUnits = baseUnits * wipeStart + extra;
      var printed = clamp(local / Math.max(1, revealUnits), 0, 1);
      var printedMotion = smoothRakel ? smoothstep(printed) : printed;
      var wipeRaw = current < scenes.length - 1 ? clamp((local - wipeStartUnits) / Math.max(1, baseUnits * (1 - wipeStart)), 0, 1) : 0;
      var wipe = smoothPull ? smoothstep(wipeRaw) : wipeRaw;
      var viewportHeight = stage.clientHeight;
      var rakelHeight = rakel.getBoundingClientRect().height;
      var bladeY = printedMotion * (viewportHeight + rakelHeight);
      var inkY = Math.min(viewportHeight, Math.max(0, bladeY - bladeLag));
      var clipBottom = Math.max(0, viewportHeight - inkY);
      scenes.forEach(function(scene, i) {
        var visible = i <= current || (i === current + 1 && wipe > 0);
        scene.classList.toggle('is-visible', visible);
        scene.classList.toggle('is-current', i === current);
        scene.style.transform = i <= current ? 'translate3d(0,0,0)' :
          'translate3d(0,' + (i === current + 1 ? (100 * (1 - wipe)).toFixed(3) : '100') + '%,0)';
        scene.style.setProperty('--kowe-clip', i < current ? '0px' : (i === current ? clipBottom.toFixed(2) + 'px' : '100%'));
        var enabled = i === current && printed > .98 && wipe < .02;
        scene.querySelectorAll('.kowe-story__action').forEach(function(link) {
          link.tabIndex = enabled ? 0 : -1;
          link.style.pointerEvents = enabled ? 'auto' : 'none';
        });
        scene.querySelectorAll('.kowe-story__carousel-arrow').forEach(function(button) {
          button.tabIndex = enabled ? 0 : -1;
          button.disabled = !enabled;
        });
        // Wellenförmiges Aufploppen nach dem Rakeldurchgang, direkt an Scrollfortschritt gebunden.
        var waveItems = scene.querySelectorAll('.kowe-story__wave-item');
        if (waveItems.length) {
          var waveProgress = i < current ? 1 : (i === current ? clamp((local - revealUnits) / Math.max(1, extra), 0, 1) : 0);
          var count = waveItems.length;
          waveItems.forEach(function(item, index) {
            var offset = count > 1 ? index / (count - 1) : 0;
            var t = clamp((waveProgress - offset * .76) / .24, 0, 1);
            var back = 1 + 2.70158 * Math.pow(t - 1, 3) + 1.70158 * Math.pow(t - 1, 2);
            var scale = .35 + .65 * back;
            item.style.opacity = clamp(t * 2.3, 0, 1).toFixed(3);
            item.style.transform = 'translate3d(0,' + ((1 - t) * 24).toFixed(1) + 'px,0) scale(' + scale.toFixed(3) + ')';
            var canClick = i === current && t > .8 && wipe < .02;
            item.tabIndex = canClick ? 0 : -1;
            item.style.pointerEvents = canClick ? 'auto' : 'none';
          });
        }
        var track = scene.querySelector('.kowe-story__carousel[data-auto="true"] .kowe-story__carousel-track');
        if (track && i === current) {
          var horizontalUnits = Math.max(1, wipeStartUnits - revealUnits);
          var horizontalProgress = clamp((local - revealUnits) / horizontalUnits, 0, 1);
          var maxOffset = Math.max(0, track.scrollWidth - track.clientWidth);
          track.scrollLeft = horizontalProgress * maxOffset;
        }
      });
      if (pull && pullImage) {
        // Die Textilkante wird mit der nächsten Farbfläche hochgezogen.
        // Die Hände ziehen gegen Ende ein Stück weiter, bis sie ganz oberhalb des Fensters liegen.
        var pullActive = current < scenes.length - 1 && wipeRaw > 0;
        if (pullActive) {
          var pullHeight = pullImage.getBoundingClientRect().height || stage.clientHeight;
          var edgeOffset = pullHeight * pullEdgePercent;
          var boundaryY = viewportHeight * (1 - wipe);
          var grabStart = smoothstep(wipe / .15);
          var handExit = smoothstep((wipe - .72) / .28);
          var travelExtra = pullHeight * .47;
          var pullY = boundaryY - edgeOffset * grabStart - travelExtra * handExit;
          pull.style.opacity = '1';
          pullImage.style.transform = 'translate3d(-50%,' + pullY.toFixed(2) + 'px,0)';
        } else {
          pull.style.opacity = '0';
          pullImage.style.transform = 'translate3d(-50%,' + stage.clientHeight + 'px,0)';
        }
      }
      rakel.style.top = bladeY.toFixed(2) + 'px';
      rakel.style.opacity = local > .001 && local < revealUnits && wipe === 0 ? '1' : '0';
      if (hint) {
        hint.style.opacity = current === 0 ? String(clamp(1 - (local/baseUnits) * 7, 0, .72)) : '0';
        hint.style.color = getComputedStyle(scenes[current]).color;
      }
    }
    root.querySelectorAll('.kowe-story__carousel-arrow').forEach(function(button) {
      button.addEventListener('click', function() {
        var track = button.closest('.kowe-story__carousel').querySelector('.kowe-story__carousel-track');
        var item = track.querySelector('.kowe-story__carousel-item');
        var step = item ? item.getBoundingClientRect().width + 20 : track.clientWidth * .75;
        track.scrollBy({left: Number(button.dataset.direction) * step, behavior:'smooth'});
      });
    });
    function schedule() {if (!frame) frame = requestAnimationFrame(draw);}
    if (pullImage && !pullImage.complete) pullImage.addEventListener('load', schedule, {once:true});
    var rakelImage = rakel.querySelector('.kowe-story__rakel-image');
    if (rakelImage && !rakelImage.complete) rakelImage.addEventListener('load', schedule, {once:true});
    function start() {
      if (active || reduced.matches) return;
      active = true;
      root.classList.add('is-animated');
      window.addEventListener('scroll', schedule, {passive:true});
      window.addEventListener('resize', schedule, {passive:true});
      draw();
    }
    function stop() {
      if (!active) return;
      active = false;
      root.classList.remove('is-animated');
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      scenes.forEach(function(scene) {
        scene.classList.remove('is-visible','is-current');
        scene.style.removeProperty('transform');
        scene.style.removeProperty('--kowe-clip');
        scene.querySelectorAll('.kowe-story__action').forEach(function(link) {
          link.removeAttribute('tabindex');
          link.style.removeProperty('pointer-events');
        });
      });
      if (pull && pullImage) {
        pull.style.removeProperty('opacity');
        pullImage.style.removeProperty('transform');
      }
    }
    function motion() {if (reduced.matches) stop();else start();}
    if (reduced.addEventListener) reduced.addEventListener('change',motion);
    else if (reduced.addListener) reduced.addListener(motion);
    start();
    document.addEventListener('shopify:section:unload', function(event) {
      if (event.target && (event.target === root || event.target.contains(root))) {
        stop();
        root.dataset.koweInitialized = 'no';
      }
    });
    document.addEventListener('shopify:block:select', function(event) {
      if (!active || !event.target || !root.contains(event.target)) return;
      var chapter = event.target.closest('.kowe-story__scene');
      if (!chapter) return;
      var index = scenes.indexOf(chapter);
      if (index < 0) return;
      var before = 0;
      for (var j=0;j<index;j++) before += sceneUnits[j];
      var targetUnits = before + Math.min(sceneUnits[index] - 1, baseUnits * (revealEnd + .1));
      var targetPixels = root.getBoundingClientRect().top + window.scrollY + (targetUnits / totalUnits) * (root.offsetHeight - stage.offsetHeight);
      window.scrollTo({top:targetPixels,behavior:'auto'});
      schedule();
    });
    }
  function initKoweStoriesIn(container) {
    if (!container) return;
    if (container.matches && container.matches('.kowe-story')) initializeKoweStory(container);
    if (container.querySelectorAll) {
      container.querySelectorAll('.kowe-story').forEach(initializeKoweStory);
    }
  }
  function onReady() { initKoweStoriesIn(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
  document.addEventListener('shopify:section:load', function (event) {
    initKoweStoriesIn(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
